import * as Html from "../../util/Html.ts";
import * as FwDatas from "../../FwDatas.ts";
export {init}
Html.registerWidget('widget/specific/eventautocomplete',{init:init})

function init(obj){

  let 
    form = obj.get(0).form,
    timetable = FwDatas.get(form.calendarId.value);
  
  obj.on('input',function(evt){
    
    if((evt.originalEvent.inputType===undefined && evt.originalEvent.data===undefined)||evt.originalEvent.inputType==="insertReplacementText"){
      let origEvent = timetable.suggestions.filter(evt=>evt.text.localeCompare(obj.val())===0)[0];
      if(origEvent){
        form.description.value=origEvent.description || '';
        form.where.value=origEvent.where|| '';
        form.color.value=origEvent.color|| '';
        $(form.color).trigger('change')
      }
      
    }
  })
  
}